var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.875 12C21.875 12.2984 21.7565 12.5845 21.5455 12.7955C21.3345 13.0065 21.0484 13.125 20.75 13.125H13.625V20.25C13.625 20.5484 13.5065 20.8345 13.2955 21.0455C13.0845 21.2565 12.7984 21.375 12.5 21.375C12.2016 21.375 11.9155 21.2565 11.7045 21.0455C11.4935 20.8345 11.375 20.5484 11.375 20.25V13.125H4.25C3.95163 13.125 3.66548 13.0065 3.4545 12.7955C3.24353 12.5845 3.125 12.2984 3.125 12C3.125 11.7016 3.24353 11.4155 3.4545 11.2045C3.66548 10.9935 3.95163 10.875 4.25 10.875H11.375V3.75C11.375 3.45163 11.4935 3.16548 11.7045 2.9545C11.9155 2.74353 12.2016 2.625 12.5 2.625C12.7984 2.625 13.0845 2.74353 13.2955 2.9545C13.5065 3.16548 13.625 3.45163 13.625 3.75V10.875H20.75C21.0484 10.875 21.3345 10.9935 21.5455 11.2045C21.7565 11.4155 21.875 11.7016 21.875 12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusss);
export default __webpack_public_path__ + "static/media/Plusss.5b9887ea4f25528592dd9a358926870b.svg";
export { ForwardRef as ReactComponent };